import { apiRequest } from "../util/apiUtils";

export const achievementList = async (params) => {
  try {
    const res = await apiRequest("get", `/achievement/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
